export function getLastFiscalYears(count = 10) {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  // If fiscal year starts in April, adjust the starting year
  const startYear = currentMonth >= 4 ? currentYear : currentYear - 1;

  const fiscalYears = [];
  for (let i = 0; i < count; i++) {
    const fromYear = startYear - i;
    const toYear = fromYear + 1;
    fiscalYears.push(`${fromYear}-${toYear}`);
  }

  return fiscalYears;
}
